import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate
} from "react-router-dom"
import { ROUTES } from "@/helpers/routes"
import { Button } from "@/ui/Button"
import styles from "./Wallet.module.scss"
import { DepositTab } from "./ui/DepositTab"
import { WithdrawTab } from "./ui/WithdrawTab"

const WALLET_TABS = [
  { key: "deposit", label: "wallet.tabs.deposit", path: ROUTES.WALLET_DEPOSIT },
  {
    key: "withdraw",
    label: "wallet.tabs.withdraw",
    path: ROUTES.WALLET_WITHDRAW
  }
] as const

export const Wallet: FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <div className={styles.Wallet}>
      <div className={styles.Wallet_title}>{t("wallet.title")}</div>
      <div className={styles.Wallet_inner}>
        <div className={styles.Wallet_content}>
          <div className={styles.Wallet_content_header}>
            <div className={styles.Wallet_nav}>
              <Button.Back link={ROUTES.HOME} />
            </div>
            <div className={styles.Wallet_content_switcher} role="tablist">
              {WALLET_TABS.map(({ key, label, path }) => (
                <button
                  key={key}
                  type="button"
                  role="tab"
                  aria-selected={location.pathname === path}
                  className={clsx(styles.Wallet_content_switcher_item, {
                    [styles.active]: location.pathname === path
                  })}
                  onClick={() => navigate(path)}
                >
                  {t(label)}
                </button>
              ))}
            </div>
          </div>
          <div className={styles.Wallet_content_body}>
            <Routes>
              <Route index element={<Navigate to="deposit" replace />} />
              <Route path="deposit" element={<DepositTab />} />
              <Route path="withdraw" element={<WithdrawTab />} />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  )
}
